import Share from 'ninelines-sharing';

import game from './game';
import globals from '../globals';
import helpers from '../helpers';

const $share = $('.kaspersky-inc-share');
const $button = $share.find('.kaspersky-inc-share__button');
const $item = $share.find('.kaspersky-inc-share__item');

$button.on('click', (e) => {
	e.preventDefault();
	e.stopPropagation();

	if (helpers.isMobile()) {
		$share.toggleClass('is-active');
	}
});

$item.on('click', (e) => {
	const $currentItem = $(e.currentTarget);

	const social = $currentItem.data('social');
	const isForResult = !!$currentItem.closest('.kaspersky-inc-share--horizontal-visible').length;
	const gameResult = game.getResult();

	let url = location.origin;

	if (isForResult && gameResult !== null) {
		url += `/wp-content/special-projects/2020/kaspersky/share.php?result=${gameResult}`;
	} else {
		location.pathname
	}

	Share[social](encodeURIComponent(url));
});

globals.$document
	.on('click', (e) => {
		if ($share.hasClass('is-active') && !$share.is(e.target) && !$share.has(e.target).length) {
			$share.removeClass('is-active');
		}
	})
	.on('keydown', (e) => {
		if ($share.hasClass('is-active') && e.keyCode === 27) {
			$share.removeClass('is-active');
		}
	});
